import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import './Councellings.css';
import Sessions from '../Councellings/Sessions';

const Home = () => (
  <div className="home-container">
    <Helmet>
      <title>Counselling Dashboard | GN VISA Admin</title>
      <meta name="description" content="View and manage all user counselling sessions from the main dashboard." />
    </Helmet>
     <div className="home-main">
      {/* <h1>Welcome to GetNextVisa Counselling</h1>
       <div className='action-cards'>
       
        <Link to="/admin/sessions" className="action-card">
          📋 View All Sessions
        </Link>
        <Link to="/admin/book-session" className="action-card">
          📅 Book a Session
        </Link>
      </div>  */}

       <Sessions/>
    </div>
    
  </div>
  
);

export default Home;
